import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import {
  Checkbox,
  FormControlLabel,
  Snackbar,
  TextField,
  Typography,
} from "@material-ui/core";

// Icon
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";

// components
import ToolTipButton from "../../components/ToolTipButton";
import Image from "../../components/Image";
import CategoryDropdown from "../Category/CategoryDropdown";
import { storage } from "../../firebase/firebase";
import { create, update } from "../../db";
import { useStateValue } from "../../store/provider";
import { permissionError } from "../../util/alert";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  closeDialog: {
    position: "absolute",
    right: "10px",
    top: "5px",
  },
  bottom: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  root: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

const AppDialog = (props) => {
  const classes = useStyles();
  const [{ admin }] = useStateValue();

  const [open, setOpen] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [name, setName] = useState("");
  const [top, setTop] = useState(false);
  const [url, setUrl] = useState("");
  const [category, setCategory] = useState("");
  const [imageData, setImageData] = useState(null);
  const [imagePath, setImagePath] = useState(null);

  const [errors, setErrors] = useState({
    name: "",
    image: "",
    category: "",
    url: "",
  });

  useEffect(() => {
    if (props.edit) {
      setName(props.app.name);
      setImagePath(props.app.icon);
      setCategory(props.app.category_id);
      setUrl(props.app.url);
      setTop(props.app.top);
    }
  }, [props.edit]);

  useEffect(
    () => () => {
      if (!open && !props.edit) {
        setName("");
        setImagePath("");
        setCategory("");
        setUrl("");
        setTop(false);

        setErrors({
          name: "",
          image: "",
          category: "",
          url: "",
        });
      }
    },
    [open, props.edit]
  );

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (!admin.flag) return permissionError();
    setOpen(true);
  };

  const handleInputFileChange = (e) => {
    if (e.target.files[0]) {
      setImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleEditImage = () => {
    document.getElementById("appImage").click();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!imageData && !imagePath) {
      return setErrors({ ...errors, image: "Please select an image." });
    } else if (!props.edit) {
      if (!imageData || !imagePath)
        return setErrors({ ...errors, image: "Please select an image." });
    }

    if (!category) {
      return setErrors({ ...errors, category: "Select a category." });
    }

    if (!name) {
      return setErrors({ ...errors, name: "Invalid value." });
    }

    if (!url) {
      return setErrors({ ...errors, url: "Invalid value." });
    }

    let fileName;

    if (imageData) {
      fileName = new Date().getTime() + imageData.name;
      const uploadTask = storage.ref(`/images/${fileName}`).put(imageData);
      setIsImageUploading(true);
      uploadTask.on(
        "state_changed",
        () => {},
        (err) => console.log(err),
        async () => {
          fileName = await storage
            .ref("images")
            .child(fileName)
            .getDownloadURL();
          setIsImageUploading(false);
          if (props.edit) {
            //  edit
            // console.log(props.category);
            await update(
              props.app._id,
              {
                name,
                top,
                icon: fileName,
                url,
                category_id: category,
              },
              "apps"
            );
            handleClose();
          } else {
            // create
            await create(
              {
                name,
                top,
                icon: fileName,
                url,
                category_id: category,
                createdAt: new Date().toISOString(),
              },
              "apps"
            );
            handleClose();
          }
        }
      );
    } else {
      fileName = imagePath;
      if (props.edit) {
        //  edit
        // console.log(props.category);
        await update(
          props.app._id,
          {
            name,
            top,
            icon: fileName,
            url,
            category_id: category,
          },
          "apps"
        );
        handleClose();
      } else {
        // create
        await create(
          {
            name,
            top,
            icon: fileName,
            url,
            category_id: category,
            createdAt: new Date().toISOString(),
          },
          "apps"
        );
        handleClose();
        // window.location.reload(true);
      }
    }
  };

  return (
    <Fragment>
      {props.edit ? (
        <ToolTipButton onClick={handleOpen} title="Edit" placement="top">
          <EditIcon color="primary" />
        </ToolTipButton>
      ) : (
        <Button color="primary" variant="contained" onClick={handleOpen}>
          Create New App
        </Button>
      )}
      <Snackbar
        open={isImageUploading}
        autoHideDuration={6000}
        onClose={() => setIsImageUploading(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert variant="filled" severity="info" style={{ textAlign: "left" }}>
          <AlertTitle>Image Information</AlertTitle>
          Be patience your <strong>Image</strong> is uploading...
        </Alert>
      </Snackbar>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-name"
      >
        <ToolTipButton
          title="Close"
          onClick={handleClose}
          btnClass={classes.closeDialog}
        >
          <CloseIcon color="primary" />
        </ToolTipButton>
        <DialogTitle id="responsive-dialog-name">App Data</DialogTitle>

        <DialogContent>
          <form onSubmit={handleSubmit}>
            <div className={classes.root}>
              <div onClick={handleEditImage}>
                <input
                  name="appImage"
                  id="appImage"
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleInputFileChange}
                />
                <Image imagePath={imagePath} />
                {errors.image && (
                  <div style={{ textAlign: "center" }}>
                    <Typography variant="caption" color="error">
                      {errors.image}
                    </Typography>
                  </div>
                )}
              </div>
              <div>
                <TextField
                  className={classes.fieldRow}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  error={errors.name ? true : false}
                  helperText={errors.name}
                  label="Name"
                  pattern="^\w+(\s+\w+)*$"
                />
                <TextField
                  className={classes.fieldRow}
                  style={{ marginTop: 15 }}
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  error={errors.url ? true : false}
                  helperText={errors.url}
                  label="URL"
                  pattern="https?://.+"
                />
                <CategoryDropdown
                  category={category}
                  error={errors.category}
                  onChange={(e) => setCategory(e.target.value)}
                />
              </div>
            </div>
            <div className={classes.bottom}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={top}
                    color="primary"
                    onChange={() => setTop(!top)}
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                }
                label="Top"
              />
              <Button variant="contained" color="primary" type="submit">
                Submit
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

AppDialog.propTypes = {
  edit: PropTypes.bool,
  app: PropTypes.object,
};

export default React.memo(AppDialog);
